<div class="tracking">

  <!-- Header com confirmacao -->
  <div class="tracking-hero">
    <div class="tracking-hero-icon">
      <i class="pi pi-check"></i>
    </div>
    <h1 class="tracking-hero-titulo">{{ 'cardapio_digital.tracking.titulo' | translate }}</h1>
    <p class="tracking-hero-subtitulo">
      {{ 'cardapio_digital.tracking.subtitulo' | translate }} {{ tracking.nomeCliente }}!
    </p>
    <span class="tracking-pedido-id">
      {{ 'cardapio_digital.tracking.pedido_numero' | translate }} #{{ tracking.codigoDePedido ? tracking.codigoDePedido : tracking.idCurto }}
    </span>
  </div>

  <!--
    Cobranca por QR (cartao ou QR Code). Fica logo abaixo do cabecalho porque e a unica coisa
    nesta tela que o cliente ainda PRECISA fazer — o resto e acompanhamento.
  -->
  <div class="tracking-qr-card" *ngIf="cobrancaQr">
    <h2 class="tracking-secao-titulo">{{ 'cardapio_digital.tracking.pagamento_titulo' | translate }}</h2>
    <p class="tracking-qr-ajuda">{{ 'cardapio_digital.tracking.pagamento_ajuda' | translate }}</p>

    <img
      *ngIf="cobrancaQr.urlQr"
      class="tracking-qr-imagem"
      [src]="cobrancaQr.urlQr"
      [alt]="'cardapio_digital.tracking.pagamento_qr_alt' | translate" />

    <!-- Copiar e colar: a imagem depende da Bancard responder, o payload nao. -->
    <div class="tracking-qr-copiar" *ngIf="cobrancaQr.qrData">
      <code class="tracking-qr-codigo">{{ cobrancaQr.qrData }}</code>
      <button type="button" class="tracking-qr-botao" (click)="copiarCodigoQr()">
        <i class="pi" [ngClass]="qrCopiado ? 'pi-check' : 'pi-copy'"></i>
        {{ (qrCopiado ? 'cardapio_digital.tracking.pagamento_copiado' : 'cardapio_digital.tracking.pagamento_copiar') | translate }}
      </button>
    </div>
  </div>

  <!-- Etapas de acompanhamento -->
  <div class="tracking-etapas-card">
    <h2 class="tracking-secao-titulo">{{ 'cardapio_digital.tracking.acompanhamento' | translate }}</h2>

    <div class="tracking-etapas">
      <div *ngFor="let etapa of etapas; let i = index; let last = last"
           class="tracking-etapa"
           [class.ativa]="etapa.ativa">
        <!-- Icone da etapa -->
        <div class="tracking-etapa-icone" [class.ativa]="etapa.ativa">
          <i class="pi" [ngClass]="etapa.icone"></i>
        </div>
        <!-- Linha conectora (exceto na ultima) -->
        <div *ngIf="!last" class="tracking-etapa-linha" [class.ativa]="etapa.ativa"></div>
        <!-- Label -->
        <span class="tracking-etapa-label">{{ etapa.label }}</span>
      </div>
    </div>
  </div>

  <!-- Itens do pedido -->
  <div class="tracking-itens-card" *ngIf="tracking.itens?.length">
    <h2 class="tracking-secao-titulo">
      {{ 'cardapio_digital.tracking.itens_pedido' | translate }}
    </h2>

    <div class="tracking-itens-lista">
      <div *ngFor="let item of tracking.itens" class="tracking-item">
        <div class="tracking-item-linha">
          <!-- Imagem do produto -->
          <img *ngIf="item.foto"
               [src]="item.foto"
               [alt]="item.nomeVariante ? item.nome + ' - ' + item.nomeVariante : item.nome"
               class="tracking-item-foto" />
          <div *ngIf="!item.foto" class="tracking-item-foto tracking-item-foto-placeholder">
            <i class="pi pi-image"></i>
          </div>

          <!-- Informacoes do item -->
          <div class="tracking-item-meta">
            <!-- Nome + variante -->
            <div class="tracking-item-nome">
              {{ item.nomeVariante ? item.nome + ' - ' + item.nomeVariante : item.nome }}
            </div>

            <!-- Modificadores estruturados (campo enriquecido) -->
            <ng-container *ngIf="item.opcoesSelecionadas?.length; else opcoesLegado">
              <ng-container *ngFor="let grupo of item.opcoesSelecionadas">
                <div class="tracking-item-grupo-titulo">{{ grupo.grupoTitulo }}</div>
                <div *ngFor="let opcao of grupo.itens" class="tracking-item-opcao">
                  <span *ngIf="opcao.quantidade > 1">{{ opcao.quantidade }}x </span>{{ opcao.titulo }}
                  <span *ngIf="opcao.valorAdicional > 0" class="tracking-item-opcao-preco">
                    +{{ formatarPreco(opcao.valorAdicional * opcao.quantidade) }}
                  </span>
                </div>
              </ng-container>
            </ng-container>

            <!-- Fallback: opcoes como lista simples (compatibilidade legada) -->
            <ng-template #opcoesLegado>
              <div *ngIf="item.opcoes?.length" class="tracking-item-opcoes-legado">
                {{ item.opcoes!.join(', ') }}
              </div>
            </ng-template>

            <!-- Comentarios do item -->
            <div *ngIf="item.comentarios" class="tracking-item-comentario">
              <span>Obs: {{ item.comentarios }}</span>
            </div>

            <!-- Quantidade x preco unitario -->
            <div class="tracking-item-detalhe">
              <span class="tracking-item-qtd-preco">
                {{ item.quantidade }}x {{ formatarPreco(item.precoUnitario) }}
              </span>
            </div>
          </div>

          <!-- Preco total do item -->
          <span class="tracking-item-preco-total">
            {{ formatarPreco(item.precoTotal) }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <!-- Informacoes do pedido -->
  <div class="tracking-info-card">
    <h2 class="tracking-secao-titulo">{{ 'cardapio_digital.tracking.resumo_pedido' | translate }}</h2>

    <!-- Tipo de pedido -->
    <div class="tracking-info-linha">
      <span class="tracking-info-chave">{{ 'cardapio_digital.tracking.tipo_pedido' | translate }}</span>
      <span class="tracking-info-valor">{{ labelTipoPedido }}</span>
    </div>

    <!-- Endereco (delivery) -->
    <div *ngIf="isDelivery && tracking.endereco" class="tracking-info-linha">
      <span class="tracking-info-chave">{{ 'cardapio_digital.checkout.endereco_entrega' | translate }}</span>
      <span class="tracking-info-valor">{{ tracking.endereco }}</span>
    </div>

    <!-- Mesa -->
    <div *ngIf="isMesa && tracking.numeroMesa" class="tracking-info-linha">
      <span class="tracking-info-chave">{{ 'cardapio_digital.checkout.numero_mesa_titulo' | translate }}</span>
      <span class="tracking-info-valor">{{ tracking.numeroMesa }}</span>
    </div>

    <!-- Subtotal (somente se ha frete) -->
    <div class="tracking-info-linha" *ngIf="tracking.frete > 0">
      <span class="tracking-info-chave">{{ 'cardapio_digital.checkout.subtotal' | translate }}</span>
      <span class="tracking-info-valor">{{ formatarPreco(tracking.subtotal) }}</span>
    </div>

    <!-- Frete -->
    <div *ngIf="isDelivery" class="tracking-info-linha">
      <span class="tracking-info-chave">
        {{ tracking.frete > 0
          ? ('cardapio_digital.tracking.frete_fixo' | translate)
          : ('cardapio_digital.checkout.frete' | translate) }}
      </span>
      <span class="tracking-info-valor" [class.tracking-frete-gratis]="tracking.frete === 0">
        {{ tracking.frete === 0 ? ('cardapio_digital.checkout.frete_gratis' | translate) : formatarPreco(tracking.frete) }}
      </span>
    </div>

    <!-- Total -->
    <div class="tracking-info-linha tracking-total">
      <span class="tracking-info-chave">{{ 'cardapio_digital.checkout.total' | translate }}</span>
      <span class="tracking-info-valor tracking-total-valor">{{ formatarPreco(tracking.total) }}</span>
    </div>
  </div>

  <!-- Informacoes de pagamento (apenas dinheiro) -->
  <div *ngIf="isDinheiro" class="tracking-pagamento-card">
    <h2 class="tracking-secao-titulo">{{ 'cardapio_digital.tracking.pagamento' | translate }}</h2>

    <div class="tracking-info-linha">
      <span class="tracking-info-chave">{{ 'cardapio_digital.tracking.forma_pagamento' | translate }}</span>
      <span class="tracking-info-valor">{{ 'cardapio_digital.checkout.pagamento_dinheiro' | translate }}</span>
    </div>

    <div *ngIf="tracking.valorPago" class="tracking-info-linha">
      <span class="tracking-info-chave">{{ 'cardapio_digital.checkout.quanto_vai_pagar' | translate }}</span>
      <span class="tracking-info-valor">{{ formatarPreco(tracking.valorPago) }}</span>
    </div>

    <div *ngIf="temTroco" class="tracking-troco-destaque">
      <i class="pi pi-wallet tracking-troco-icone"></i>
      <div class="tracking-troco-texto">
        <span class="tracking-troco-label">{{ 'cardapio_digital.tracking.troco_label' | translate }}</span>
        <span class="tracking-troco-valor">{{ formatarPreco(tracking.troco!) }}</span>
      </div>
    </div>

    <div *ngIf="isDinheiro && !temTroco && tracking.troco === 0" class="tracking-sem-troco">
      <i class="pi pi-check-circle"></i>
      <span>{{ 'cardapio_digital.checkout.sem_troco' | translate }}</span>
    </div>
  </div>

  <!-- Botoes de acao -->
  <div class="tracking-footer">
    <button class="tracking-btn-copiar" type="button" (click)="abrirModalCopiar()">
      <i class="pi pi-copy"></i>
      {{ texts.tracking?.copiar_pedido || 'Repetir pedido' }}
    </button>

    <!-- Botao voltar ao historico (quando vem do historico de pedidos) -->
    <button *ngIf="veioDoHistorico" class="tracking-btn-voltar" type="button" (click)="onVoltarDoHistorico()">
      <i class="pi pi-arrow-left"></i>
      {{ 'cardapio_digital.tracking.voltar_historico' | translate }}
    </button>

    <!-- Botao voltar ao cardapio (quando vem de um pedido novo) -->
    <button *ngIf="!veioDoHistorico" class="tracking-btn-voltar" type="button" (click)="onVoltarAoCardapio()">
      {{ 'cardapio_digital.tracking.voltar_cardapio' | translate }}
    </button>
  </div>

</div>

<!-- Modal de confirmacao para copiar pedido -->
<div *ngIf="modalCopiarVisivel"
     class="tracking-modal-overlay"
     (click)="fecharModalCopiar()">
  <div class="tracking-modal-copiar" (click)="$event.stopPropagation()">
    <button class="tracking-modal-fechar" type="button" (click)="fecharModalCopiar()" aria-label="Fechar">
      <i class="pi pi-times"></i>
    </button>

    <h3 class="tracking-modal-titulo">
      {{ texts.tracking?.copiar_confirmar_titulo || 'Repetir este pedido?' }}
    </h3>

    <p class="tracking-modal-mensagem">
      {{ texts.tracking?.copiar_confirmar_mensagem || 'Os itens deste pedido serao adicionados ao seu carrinho.' }}
    </p>
    <p *ngIf="carrinhoTemItens" class="tracking-modal-aviso">
      {{ texts.tracking?.copiar_confirmar_carrinho_existente || 'Seu carrinho atual sera substituido.' }}
    </p>

    <div class="tracking-modal-acoes">
      <button class="tracking-modal-btn-cancelar" type="button" (click)="fecharModalCopiar()">
        {{ texts.tracking?.copiar_cancelar_btn || 'Cancelar' }}
      </button>
      <button class="tracking-modal-btn-confirmar" type="button" (click)="confirmarCopiarPedido()">
        <i class="pi pi-copy"></i>
        {{ texts.tracking?.copiar_confirmar_btn || 'Sim, repetir' }}
      </button>
    </div>
  </div>
</div>

<!-- Modal "Quase pronto..." com botao de envio pelo WhatsApp -->
<div *ngIf="modalWhatsappVisivel && tracking?.linkWhatsapp"
     class="tracking-modal-overlay"
     (click)="fecharModalWhatsapp()">
  <div class="tracking-modal-whatsapp" (click)="$event.stopPropagation()">
    <!-- Botao fechar -->
    <button class="tracking-modal-fechar" type="button" (click)="fecharModalWhatsapp()" aria-label="Fechar">
      <i class="pi pi-times"></i>
    </button>

    <h3 class="tracking-modal-titulo">{{ 'cardapio_digital.tracking.quase_pronto_titulo' | translate }}</h3>

    <div class="tracking-modal-acao-card">
      <span class="tracking-modal-acao-label">
        {{ 'cardapio_digital.tracking.acao_necessaria' | translate }}
        <i class="tracking-modal-acao-icone">👆</i>
      </span>
      <p class="tracking-modal-acao-descricao">{{ 'cardapio_digital.tracking.acao_whatsapp' | translate }}</p>
    </div>

    <button class="tracking-modal-btn-enviar" type="button" (click)="onEnviarWhatsapp()">
      <i class="pi pi-whatsapp"></i>
      {{ 'cardapio_digital.tracking.enviar_whatsapp' | translate }}
    </button>
  </div>
</div>
